export { default } from './send-icon-2'
